<template>
  <div class="show-if-select">
    <multiselect
      class="multi-select-question"
      id="ajax"
      v-model="conditionalQuestion"
      label="label"
      track-by="slug"
      :allow-empty="true"
      :options="questions"
      @search-change="asyncFind"
      :searchable="true"
      :loading="isLoading"
      placeholder="Type to search"
      :options-limit="15"
    >
      <template slot="singleLabel" slot-scope="{ option }"
        >{{ option.sectionName }} > {{ option.pageName }} >
        {{ option.label }}</template
      >
    </multiselect>
    <input
      v-if="conditionalQuestion"
      type="hidden"
      :name="inputName('slug')"
      v-model="conditionalQuestion.slug"
    />

    <div v-if="conditionalQuestion" class="equality-operator">
      <select :name="inputName('operator')" v-model="operator" id="">
        <option value="=">equal to</option>
        <option value="!=">not equal to</option>
      </select>
    </div>

    <div
      class="multi-select-value"
      v-if="conditionalQuestion && conditionalQuestion.includesOptions"
    >
      <multiselect
        :name="inputName('value')"
        v-model="conditionalValue"
        label="text"
        track-by="slug"
        :options="conditionalQuestion.options"
        :multiple="true"
        :searchable="true"
      >
      </multiselect>
      <!-- Hidden input for conditional value array -->
      <div v-for="n in conditionalValue" :key="n">
        <input
          v-model="n.slug"
          type="hidden"
          :name="inputName('value') + '[]'"
        />
      </div>
    </div>
    <div class="multi-select-value" v-else-if="conditionalQuestion">
      <input
        v-model="conditionalValue"
        type="text"
        :name="inputName('value')"
        required
      />
    </div>

    <button
      v-if="conditionalValue"
      class="btn"
      type="button"
      @click.prevent="addShowConditionField()"
    >
      +
    </button>
    <button class="btn" type="button" @click.prevent="removeCondition(index)">
      -
    </button>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['moduleId', 'index', 'condition'],

  data() {
    return {
      conditionalQuestion: null,
      conditionalValue: null,
      operator: this.condition.operator,
      questions: [],
      isLoading: false,
    };
  },

  methods: {
    asyncFind() {
      this.isLoading = true;
      axios
        .get(
          'http://formengine-v2.local/admin/module-management/json/1/questions'
        )
        .then((response) => {
          this.questions = response.data.data;
          this.isLoading = false;

          this.populateExistingConditions();
        });
    },

    // Emit an event that the user wants a new show condiiton field
    addShowConditionField() {
      this.$emit('new-show-condition');
    },
    removeCondition(index) {
      alert('sendin event to parent');
      this.$emit('remove', index);
    },

    inputName(type) {
      return 'show_condition[' + this.index + '][' + type + ']';
    },

    // Populate existing conditions if we have them
    populateExistingConditions() {
      if (this.condition) {
        // Populate the condionlQuestion
        this.conditionalQuestion = this.questions.find((question) => {
          return question.slug == this.condition.slug;
        });

        // Populate the conditonValue
        if (Array.isArray(this.condition.value)) {
          this.conditionalValue = this.conditionalQuestion.options.filter(
            (option) => {
              return this.condition.value.includes(option.slug);
            }
          );
        } else {
          this.conditionalValue = this.condition.value;
        }
      }
    },
  },

  created() {
    if (this.condition) {
      // Load the questions
      this.asyncFind();
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__select {
  display: none;
}

.multiselect__tags {
  border: 2px solid #cacaca;
  border-radius: 0;
  padding-top: 16px;
  padding-bottom: 14px;
}

.multiselect__tags input[type='text'] {
  border: 0 solid #fff;
}

.multiselect__single {
  color: initial;
  font-size: 1.3em;
}

.multiselect__tag {
  margin-bottom: 0;
}

.show-if-select {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.show-if-select .multi-select-question,
.multi-select-value {
  margin-top: 1em;
  flex-basis: 70%;
}

.show-if-select div {
  margin-right: 0.5em;
}
</style>
